export default __webpack_public_path__ + "static/media/Card-LatitudeEcoMastercard.4e88d6aa.png";